import { useState } from "react";
import { Card, CardHeader, CardBody, Col, Row, Button } from "reactstrap";
import { PacmanLoader } from "react-spinners";
import { GetAdminCourses, GetOrphanCourses } from "../../actions/adminQueries";
import ProgramLicenseCourseComponent from "../../components/ProgramLicense/ProgramLicenseCourseComponent";
import AddCourseToProgramLicenseModal from "../../components/ProgramLicense/AddCourseToProgramLicenseModal";
import CourseAdminNav from "../../components/Navigation/CourseAdminNav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import { toast } from "react-toastify";
import ModifyProgramLicenseModal from "../../components/Modal/ModifyProgramLicenseModal";
import SetCourseOrderInLicenseModal from "../../components/Modal/SetCourseOrderInLicenseModal";
import AddNewProgramModal from "../../components/ProgramLicense/AddNewProgramModal";
import { FormattedMessage } from "react-intl";

export default function ProgramLicenses() {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedLicenseId, setSelectedLicenseId] = useState(0);
  const [selectedLicenseName, setSelectedLicenseName] = useState("");
  const [postingCourseToLicense, setPostingCourseToLicense] = useState(false);
  const [removingCourseFromLicense, setRemovingCourseFromLicense] = useState([]);
  const [sortModalIsOpen, setSortModalIsOpen] = useState(false);
  const [newProgramModalIsOpen, setNewProgramModalIsOpen] = useState(false);
  const [editLicenseModalIsOpen, setEditLicenseModalIsOpen] = useState(false);
  const [selectedLicenseImage, setSelectedLicenseImage] = useState(null);

  const courses = GetAdminCourses();
  const orphanCourses = GetOrphanCourses();

  const disconnect = (licenseName, courseId) => {
    setRemovingCourseFromLicense([{ licenseName, courseId }]);
    axios
      .delete(
        `${API_BASE_URL}/ProgramLicense/RemoveCoursesFromProgramLicense?licenseName=${licenseName}&courseId=${courseId}`
      )
      .then(() => {
        toast.success("Kursen har plockats bort ifrån programlicensen");
        setRemovingCourseFromLicense((prev) =>
          prev.filter((item) => item.licenseName !== licenseName && item.courseId !== courseId)
        );
        refresh();
      })
      .catch((err) => {
        toast.warn(
          err?.response?.data || "Det gick inte att koppla ifrån kursen ifrån programlicensen"
        );
        setRemovingCourseFromLicense((prev) =>
          prev.filter((item) => item.licenseName !== licenseName && item.courseId !== courseId)
        );
      });
  };

  const refresh = () => {
    courses.refetch();
    orphanCourses.refetch();
  };

  const addCourses = (coursesToAdd) => {
    setPostingCourseToLicense(true);
    axios
      .post(
        `${API_BASE_URL}/ProgramLicense/AddCoursesToProgramLicense?licenseName=${selectedLicenseName}&courseIds=${coursesToAdd.map((x) => x.value).join("&courseIds=")}`
      )
      .then(() => {
        toast.success("Kurserna har lagts till i programlicensen");
        setPostingCourseToLicense(false);
        refresh();
        toggleAddCourseModal(0, "");
      })
      .catch((err) => {
        toast.warn(
          err?.response?.data || "Det gick inte att lägga till kurserna i programlicensen"
        );
        setPostingCourseToLicense(false);
      });
  };

  const toggleAddCourseModal = (licenseId, licenseName) => {
    setModalIsOpen((prev) => !prev);
    setSelectedLicenseId(licenseId);
    setSelectedLicenseName(licenseName);
  };

  const toggleSortModal = () => {
    setSortModalIsOpen((prev) => !prev);
  };

  if (courses.isPending) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  const coursesData = courses.data || [];

  let mappedLicense = [];

  if (coursesData.length > 0)
    mappedLicense = coursesData.map((license, i) => {
      return (
        <Col lg="4" key={i}>
          <Card>
            <CardHeader>
              <div className="d-flex align-items-center m-1">
                <Col lg="8" className="me-3">
                  {license.program.licenseName}
                </Col>
                <Col lg="4">
                  <Button
                    outline
                    size="sm"
                    title="Lägg till kurser"
                    color="primary"
                    className="me-2"
                    onClick={() => {
                      setModalIsOpen((prev) => !prev);
                      setSelectedLicenseId(license.program.id);
                      setSelectedLicenseName(license.program.licenseName);
                    }}
                  >
                    <FontAwesomeIcon icon="plus" />
                  </Button>
                  <Button
                    outline
                    size="sm"
                    title="Ändra sorteringsordning"
                    color="primary"
                    className="me-2"
                    onClick={() => {
                      setSortModalIsOpen((prev) => !prev);
                      setSelectedLicenseId(license.program.id);
                    }}
                  >
                    <FontAwesomeIcon icon="edit" />
                  </Button>
                  <Button
                    outline
                    size="sm"
                    title="Redigera programlicens"
                    color="primary"
                    onClick={() => {
                      setEditLicenseModalIsOpen((prev) => !prev);
                      setSelectedLicenseId(license.program.id);
                      setSelectedLicenseName(license.program.licenseName);
                      setSelectedLicenseImage(license.program.image);
                    }}
                  >
                    <FontAwesomeIcon icon="image" />
                  </Button>
                </Col>
              </div>
            </CardHeader>
            <CardBody>
              <ProgramLicenseCourseComponent
                program={license.program}
                courses={license.courses}
                disconnect={disconnect}
                removingCourseFromLicense={removingCourseFromLicense}
              />
            </CardBody>
          </Card>
        </Col>
      );
    });

  return (
    <div>
      <CourseAdminNav location="licenses" />
      <div className="animated fadeIn">
        <div className="container-fluid admin-container">
          <Row className="mb-2">
            <Col>
              <Button
                outline
                color="primary"
                onClick={() => setNewProgramModalIsOpen(true)}
                className="mb-2"
              >
                <FormattedMessage id="AddNewProgram" />
              </Button>
            </Col>
          </Row>
          <Row>{mappedLicense}</Row>
          <ModifyProgramLicenseModal
            isOpen={editLicenseModalIsOpen}
            toggle={() => setEditLicenseModalIsOpen((prev) => !prev)}
            licenseId={selectedLicenseId}
            licenseName={selectedLicenseName}
            licenseImage={selectedLicenseImage}
          />
          <SetCourseOrderInLicenseModal
            isOpen={sortModalIsOpen}
            toggle={toggleSortModal}
            courses={
              selectedLicenseId
                ? coursesData.find(
                    (item) => item.program.id === selectedLicenseId
                  )?.courses || []
                : []
            }
            licenseId={selectedLicenseId}
          />
          <AddCourseToProgramLicenseModal
            isOpen={modalIsOpen}
            licenseId={selectedLicenseId}
            licenseName={selectedLicenseName}
            toggle={toggleAddCourseModal}
            addCourses={addCourses}
            posting={postingCourseToLicense}
          />
          <AddNewProgramModal
            isOpen={newProgramModalIsOpen}
            toggle={() => setNewProgramModalIsOpen((prev) => !prev)}
          />
        </div>
      </div>
    </div>
  );
}
